import { IS_USE_PLEX_API } from '../../constants';
import { useLoadCasinoCollectionData } from '../useLoadCasinoCollectionData';
import { useLoadCasinoFeed } from '../useLoadCasinoFeed';
import { useLoadDynamicRecommendedGames } from '../useLoadDynamicRecommendedGames';
import { useLoadFavoritesList } from '../useLoadFavoritesList';
import { useLoadFeedProviders } from '../useLoadFeedProviders';
import { useLoadLiveRtpGames } from '../useLoadLiveRtpGames';
import { useLoadRecentlyPlayed } from '../useLoadRecentlyPlayed';
import { useLoadRecommendedGames } from '../useLoadRecommendedGames';
import { useLoadWagerSlotsGames } from '../useLoadWagerSlotsGames';
import { useResetDataOnLangPlatformChange } from '../useResetDataOnLangPlatformChange';

export const useLoadCasinoDataOld = ({
  feedNames = '',
  casinoType,
  isRecentDataRequired
}) => {
  useLoadCasinoFeed({ feedNames });

  useLoadCasinoCollectionData({ casinoType });

  useLoadFavoritesList(casinoType, feedNames);
  useLoadRecentlyPlayed(casinoType, { isRecentDataRequired });
  useLoadRecommendedGames(casinoType);
  useLoadWagerSlotsGames();
  useLoadLiveRtpGames(feedNames);
  useLoadDynamicRecommendedGames({ feedNames, casinoType });
};

const useLoadCasinoDataPlex = ({
  feedNames = '',
  casinoType,
  limit,
  isRecentDataRequired
}) => {
  useLoadCasinoFeed({ feedNames, casinoType, limit });
  useLoadFeedProviders({ feedName: feedNames, casinoType, limit: 1 });

  useLoadCasinoCollectionData({ casinoType });

  useResetDataOnLangPlatformChange();

  useLoadFavoritesList(casinoType, feedNames);
  useLoadRecentlyPlayed(casinoType, {
    feedName: feedNames,
    limit,
    isRecentDataRequired
  });
  useLoadRecommendedGames(casinoType, feedNames, limit);
  useLoadWagerSlotsGames(feedNames, limit);
  useLoadLiveRtpGames(feedNames, casinoType, limit);
  useLoadDynamicRecommendedGames({ feedNames, limit, casinoType });
};

export const useLoadCasinoData = IS_USE_PLEX_API
  ? useLoadCasinoDataPlex
  : useLoadCasinoDataOld;
